export default "__VITE_ASSET__WuXcGik5__"